import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Hacker News brand icon
 * Source: Font Awesome Free 7.1.0
 */
export function HackerNewsIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 640 640">
      <path d="M96 96L96 544L544 544L544 96L96 96zM117.2 293.2L117 293.2C117.1 293.1 117.2 292.9 117.3 292.8C117.3 292.9 117.3 293.1 117.2 293.2zM335.2 347.1L335.2 448L303.8 448L303.8 345.3L224 192L261.3 192C313.8 290.3 310.5 293.2 320.6 317.6C332.9 290.6 326.4 293.2 381.2 192L416 192L335.2 347.1z"/>
    </SvgIcon>
  );
}
